<template>
    <div class="ui-content dashboard">
            <div class="data-table-section health-report chapter-hltmain chapter-healthStore">
                <v-row>
                    <v-col col="3" sm="3" class="border-right-health">
                        <div class="fix-left-progress feb-18-chapter-health">
                            <div class="chapter-halth-progress">
                                <div class="vertical-progress">
                                    <div
                                        :class="selectedSubject.health >= 85 ? 'plus-80-percenage-count' : 'less-percentage'"
                                        v-if="selectedSubject.health <= 10"
                                    >
                                        <div class="percenage-count">{{selectedSubject.health + '%'}}</div>
                                    </div>
                                    <div
                                        class="progress-percentage"
                                        :style="{background: getColor(selectedSubject.health),height: selectedSubject.health+'%'}"
                                    >
                                        <div
                                            class="calc-percentage"
                                            v-if="selectedSubject.health > 10"
                                        >{{selectedSubject.health + '%'}}</div>
                                    </div>
                                </div>
                                <div class="sub-health">Subject Health</div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
    </div>
</template>
<script>
import ProgressBar from "@/components/common/ProgressBar.vue";
import { mapActions, mapState } from "vuex";

export default {
    components: {
        ProgressBar
    },
    props: ["selectedSubject", "studentId"],
    data() {
        return {};
    },
    methods: {
        ...mapActions({
            setSelectedChapter: "healthStore/setSelectedChapter"
        }),
        getColor(percentage) {
            let color = "";

            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        }
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
};
</script>